import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import PropertyTypes from '../components/PropertyTypes/PropertyTypes';
import Properties from '../components/Properties/Properties';
import WhyUs from '../components/WhyUs/WhyUs';
import Testimonials from '../components/Testimonials/Testimonials';
import Agents from '../components/Agents/Agents';
import Newsletter from '../components/Newsletter/Newsletter';
import Footer from '../components/Footer/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <Hero />
      <PropertyTypes />
      <Properties />
      <WhyUs />
      {/* <Testimonials/> */}
      {/* <Agents /> */}
      {/* <Newsletter/> */}
      <Footer />
    </>
  )
}
